import Card from './Card';
import { Box, Flex } from './layouts';
import Button from './Button';
import { useNavigate } from 'react-router-dom';

const PlaceholderCard = ({ title, actionText, actionUrl }) => {
  const navigate = useNavigate();

  return (
    <Card py={{ tablet: 'm', desktop: 'm' }}>
      <Flex
        flexDirection={{ mobile: 'column', tablet: 'row' }}
        justifyContent={'space-between'}
        alignItems={{ mobile: 'flex-start', tablet: 'center' }}
        css={({ space }) => ({ gap: space?.l || '24px' })}
      >
        <Box fontScale={'l'} fontWeight={'bold'}>
          {title}
        </Box>
        <Button
          variant={'primary'}
          onClick={() => navigate(actionUrl)}
        >
          {actionText}
        </Button>
      </Flex>
    </Card>
  );
};

export default PlaceholderCard;
